import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetosambhajinagaraurangabadcab() {



    const cardData = {

keyword: "Pune to Sambhaji Nagar Aurangabad Cab",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Pune to Sambhaji Nagar Aurangabad Cab services for families, business travelers, pilgrims, and tourists. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles with experienced chauffeurs for a safe and smooth highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether you are planning a heritage tour, business trip, or family vacation, Rising Cab Service ensures a hassle-free travel experience from Pune to Sambhaji Nagar (Aurangabad).",

topPlaces: [
    {
        title: "Ajanta Caves",
        description:
            "Ajanta Caves are a UNESCO World Heritage Site renowned for their ancient Buddhist rock-cut caves, intricate paintings, and remarkable sculptures dating back over 2,000 years."
    },
    {
        title: "Ellora Caves",
        description:
            "Ellora Caves are among India's greatest archaeological treasures, featuring Hindu, Buddhist, and Jain cave temples, including the magnificent Kailasa Temple carved from a single rock."
    },
    {
        title: "Bibi Ka Maqbara",
        description:
            "Bibi Ka Maqbara is a stunning Mughal-era monument often referred to as the 'Mini Taj Mahal' because of its beautiful architecture and historical significance."
    },
    {
        title: "Daulatabad Fort",
        description:
            "Daulatabad Fort is a massive hill fort famous for its strategic military architecture, ancient tunnels, and panoramic views of the surrounding region."
    },
    {
        title: "Grishneshwar Jyotirlinga Temple",
        description:
            "Grishneshwar Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and an important pilgrimage destination located near Ellora Caves."
    },
    {
        title: "Panchakki",
        description:
            "Panchakki is a historic water mill built during the Mughal period, known for its ingenious water management system and peaceful surroundings."
    },
    {
        title: "Bhadra Maruti Temple",
        description:
            "Bhadra Maruti Temple in Khuldabad is one of the few temples in India featuring a reclining idol of Lord Hanuman and is a significant pilgrimage site."
    },
    {
        title: "Aurangabad Caves",
        description:
            "Aurangabad Caves are ancient Buddhist rock-cut caves featuring beautiful carvings and sculptures that reflect the region's rich cultural heritage."
    },
    {
        title: "Jayakwadi Dam",
        description:
            "Jayakwadi Dam is one of Maharashtra's largest dams and a popular tourist spot known for its scenic reservoir, bird sanctuary, and beautiful sunset views."
    },
    {
        title: "Siddharth Garden and Zoo",
        description:
            "Siddharth Garden and Zoo is a family-friendly attraction in Sambhaji Nagar featuring landscaped gardens, a zoo, and recreational facilities for visitors of all ages."
    }
],



services: [
    {
        name: "Pune to Aurangabad Cab",
        description:
            "Rising Cab Service offers Pune to Aurangabad Cab for safe, reliable, and comfortable intercity travel across Maharashtra. Whether you are planning a business trip, family vacation, pilgrimage, or sightseeing tour, our service provides well-maintained AC vehicles, professional drivers, and flexible travel options. Customers can choose from hatchbacks, sedans, SUVs, Innova, and Innova Crysta for one-way and round-trip journeys with doorstep pickup and drop. With 24x7 availability, transparent pricing, and experienced highway chauffeurs, we ensure a smooth and enjoyable journey from Pune to Aurangabad (Chhatrapati Sambhajinagar)."
    },
    {
        name: "Pune to Sambhaji Nagar Cab",
        description:
            "Book Pune to Sambhaji Nagar Cab with Rising Cab Service for affordable and hassle-free travel. Our comfortable vehicles and skilled drivers provide safe transportation for family, business, and leisure trips with flexible scheduling and reliable service."
    },
    {
        name: "Pune to Sambhajinagar Cab Service",
        description:
            "Rising Cab Service provides Pune to Sambhajinagar Cab Service with clean AC vehicles, experienced drivers, and convenient booking options for one-way and round-trip travel."
    },
    {
        name: "Pune to Sambhaji Nagar Taxi Service",
        description:
            "Our Pune to Sambhaji Nagar Taxi Service offers dependable long-distance transportation with professional chauffeurs, affordable pricing, and comfortable travel for every passenger."
    },
    {
        name: "Pune to Sambhajinagar Cab Booking",
        description:
            "Book Pune to Sambhajinagar Cab Booking with instant confirmation, multiple vehicle choices, and 24x7 customer support for a convenient travel experience."
    },
    {
        name: "Best Pune to Sambhaji Nagar Cab",
        description:
            "Choose the Best Pune to Sambhaji Nagar Cab with Rising Cab Service for premium comfort, reliable service, and experienced drivers ensuring safe highway travel."
    },
    {
        name: "One Way Pune to Sambhajinagar Cab",
        description:
            "Our One Way Pune to Sambhajinagar Cab service provides economical single-trip travel with doorstep pickup, professional drivers, and comfortable AC vehicles."
    },
    {
        name: "Round Trip Pune to Sambhaji Nagar Taxi",
        description:
            "Rising Cab Service offers Round Trip Pune to Sambhaji Nagar Taxi with flexible return schedules, waiting options, and customized travel plans for families and business travelers."
    },
    {
        name: "Cheap Pune to Sambhajinagar Cab",
        description:
            "Book Cheap Pune to Sambhajinagar Cab for affordable long-distance travel without compromising on comfort, safety, or service quality."
    },
    {
        name: "24x7 Pune to Sambhaji Nagar Cab Service",
        description:
            "Our 24x7 Pune to Sambhaji Nagar Cab Service is available anytime with instant booking, professional chauffeurs, and reliable transportation for urgent and planned trips."
    },
    {
        name: "Outstation Cab Pune to Sambhajinagar",
        description:
            "Rising Cab Service provides Outstation Cab Pune to Sambhajinagar with flexible travel plans, comfortable vehicles, and experienced drivers for safe intercity journeys."
    },
    {
        name: "Pune to Aurangabad Cab Service",
        description:
            "Book Pune to Aurangabad Cab Service for comfortable and dependable travel with well-maintained vehicles and trained drivers for business, family, and tourism travel."
    },
    {
        name: "Pune to Aurangabad Taxi Service",
        description:
            "Our Pune to Aurangabad Taxi Service ensures smooth, safe, and budget-friendly transportation with clean AC vehicles and experienced highway drivers."
    },
    {
        name: "Pune to Aurangabad Cab Booking",
        description:
            "Rising Cab Service offers Pune to Aurangabad Cab Booking with instant confirmation, easy reservations, and multiple vehicle options for every travel requirement."
    },
    {
        name: "Best Pune to Aurangabad Cab",
        description:
            "Choose the Best Pune to Aurangabad Cab for premium travel comfort, punctual service, and professional chauffeurs ensuring a pleasant journey."
    },
    {
        name: "One Way Pune to Aurangabad Cab",
        description:
            "Book One Way Pune to Aurangabad Cab for affordable point-to-point travel with transparent pricing and comfortable AC vehicles."
    },
    {
        name: "Round Trip Pune to Aurangabad Taxi",
        description:
            "Our Round Trip Pune to Aurangabad Taxi service offers flexible return options, waiting facilities, and customized travel plans for families and groups."
    },
    {
        name: "Cheap Pune to Aurangabad Cab",
        description:
            "Rising Cab Service provides Cheap Pune to Aurangabad Cab with economical pricing and reliable transportation for budget-conscious travelers."
    },
    {
        name: "Pune to Aurangabad Taxi Fare",
        description:
            "Get transparent Pune to Aurangabad Taxi Fare with competitive rates and no hidden charges for one-way, round-trip, and customized travel plans."
    },
    {
        name: "Sedan Pune to Aurangabad Cab",
        description:
            "Our Sedan Pune to Aurangabad Cab is ideal for solo travelers and small families seeking economical and comfortable long-distance travel."
    },
    {
        name: "SUV Pune to Aurangabad Taxi",
        description:
            "Book SUV Pune to Aurangabad Taxi for spacious seating, additional luggage space, and comfortable travel for groups and families."
    },
    {
        name: "Innova Pune to Aurangabad Cab",
        description:
            "Rising Cab Service offers Innova Pune to Aurangabad Cab with premium comfort, spacious interiors, and smooth highway travel for larger groups."
    },
    {
        name: "Highway Cab Pune Aurangabad",
        description:
            "Our Highway Cab Pune Aurangabad service provides safe and efficient long-distance travel with experienced highway drivers and well-maintained vehicles."
    }
],

tableData: [
    ["Pune to Aurangabad Cab", "Pune to Sambhaji Nagar Cab"],
    ["Pune to Aurangabad Cab Service", "Pune to Sambhajinagar Cab Service"],
    ["Pune to Aurangabad Taxi Service", "Pune to Sambhaji Nagar Taxi Service"],
    ["Pune to Aurangabad Cab Booking", "Pune to Sambhajinagar Cab Booking"],
    ["Best Pune to Aurangabad Cab", "Best Pune to Sambhaji Nagar Cab"],
    ["One Way Pune to Aurangabad Cab", "One Way Pune to Sambhajinagar Cab"],
    ["Round Trip Pune to Aurangabad Taxi", "Round Trip Pune to Sambhaji Nagar Taxi"],
    ["Cheap Pune to Aurangabad Cab", "Cheap Pune to Sambhajinagar Cab"],
    ["24x7 Pune to Sambhaji Nagar Cab Service", "Outstation Cab Pune to Sambhajinagar"],
    ["Pune to Aurangabad Taxi Fare", "Highway Cab Pune Aurangabad"],
    ["Sedan Pune to Aurangabad Cab", "SUV Pune to Aurangabad Taxi"],
    ["Innova Pune to Aurangabad Cab", "Pune to Aurangabad Cab Service"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Chhatrapati Sambhajinagar Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Sambhajinagar (Aurangabad) cab transportation for families, tourists, pilgrims, business travelers, and students."
    },
    {
        WhyChooseheading: "Perfect for Heritage and Tourism Travel",
        WhyChoosedescription: "Travel conveniently to world-famous attractions including Ajanta Caves, Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Long-Distance Journeys",
        WhyChoosedescription: "Our fleet includes Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for every travel requirement."
    },
    {
        WhyChooseheading: "One-Way, Round Trip, and Tour Packages",
        WhyChoosedescription: "Customers can choose one-way cab services, return journeys, sightseeing packages, and customized travel plans according to their schedule."
    },
    {
        WhyChooseheading: "Popular Choice for Pilgrimage Tours",
        WhyChoosedescription: "Many devotees use our cab service to visit Grishneshwar Jyotirlinga, Bhadra Maruti Temple, and other important religious destinations near Sambhajinagar."
    },
    {
        WhyChooseheading: "Pickup Available from All Pune Locations",
        WhyChoosedescription: "We provide doorstep pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and nearby areas."
    },
    {
        WhyChooseheading: "Flexible Sightseeing Stops During Travel",
        WhyChoosedescription: "Travelers can customize their journey with additional stops for temples, tourist attractions, restaurants, and nearby destinations."
    },
    {
        WhyChooseheading: "Safe and Professional Travel Experience",
        WhyChoosedescription: "Rising Cab Service focuses on passenger comfort, punctuality, and reliable transportation throughout the Pune to Sambhajinagar route."
    }
]
};

const faqData = [
    {
        question: "What are the major tourist attractions in Sambhajinagar?",
        answer: "Popular attractions include Ajanta Caves, Ellora Caves, Bibi Ka Maqbara, Daulatabad Fort, Panchakki, and Grishneshwar Jyotirlinga."
    },
    {
        question: "Can I hire a one-way cab from Pune to Sambhajinagar?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for family travel?",
        answer: "Ertiga and Innova Crysta are among the most preferred options for family journeys due to their comfort and spacious seating."
    },
    {
        question: "Do you provide cabs for Ajanta and Ellora sightseeing?",
        answer: "Yes, customers can combine Sambhajinagar travel with Ajanta-Ellora sightseeing packages."
    },
    {
        question: "Can pilgrims visit Grishneshwar Jyotirlinga during the trip?",
        answer: "Yes, Grishneshwar Temple can be included in the travel itinerary along with other nearby religious destinations."
    },
    {
        question: "Are Tempo Travellers available for group tours?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for family groups, educational tours, and corporate outings."
    },
    {
        question: "Is same-day return travel available?",
        answer: "Yes, same-day return packages can be arranged depending on the customer's schedule and travel requirements."
    },
    {
        question: "Can business travelers use this service for official visits?",
        answer: "Yes, many professionals travel to Sambhajinagar for meetings, industrial visits, and corporate assignments."
    },
    {
        question: "Are pickups available from Pune Airport and Railway Station?",
        answer: "Yes, passengers can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "How can I book a Pune to Sambhajinagar Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Santosh Deshmukh",
        feedback:
            "We planned an Ajanta-Ellora tour from Pune and the entire journey was organized exceptionally well. The vehicle was comfortable and the trip was enjoyable throughout.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Kulkarni",
        feedback:
            "Our family visited Grishneshwar Temple and nearby attractions using Rising Cab Service. Everything was managed professionally and the travel experience was excellent.",
        rating: 5
    }
];


    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];











const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Sambhaji Nagar (Aurangabad) Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-aurangabad-cab.jpg",
"description": "Book Pune to Sambhaji Nagar (Aurangabad) Cab Service with Rising Cab Service for safe, comfortable, and affordable intercity travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars for family and business trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-aurangabad-cab"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Sambhaji Nagar Cab (Aurangabad) | Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Sambhaji Nagar (Aurangabad) Cab Service for safe and comfortable intercity travel. Get affordable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars."
/>

<meta
 name="keywords"
 content="pune to aurangabad cab, pune to sambhaji nagar taxi, cab from pune to aurangabad, taxi from pune to aurangabad, pune to aurangabad cab service, pune to aurangabad taxi fare, pune to aurangabad one way cab, pune to aurangabad round trip taxi, pune to aurangabad cab booking, cheap pune to aurangabad cab, best pune to sambhaji nagar cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/46.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetosambhajinagaraurangabadcab;